import { CardHeader } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { getExperienceHeaderBackgroundByType } from './Types';
import { observer } from 'mobx-react';
import ExperiencesHeaderLogo from './ExperiencesHeaderLogo';
import { ExperienceResource } from '../../../../../../../CurrentCollectionStep/BuilderV2/Types';
import ExperienceHeaderEndIcon from './ExperiencesHeaderEndIcon';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceCardHeader({ experienceResource }: Props) {
  return (
    <CardHeader
      className={clsx(
        'h-14 py-1.5',
        getExperienceHeaderBackgroundByType(experienceResource.payload),
      )}
      endContent={<ExperienceHeaderEndIcon experienceResource={experienceResource} />}
    >
      <ExperiencesHeaderLogo experienceResource={experienceResource} />
    </CardHeader>
  );
}

export default observer(ExperienceCardHeader);
